// extracted by mini-css-extract-plugin
export default {"mainGreen":"#5EDE99","makerBoxShadowGreen":"0 0 3px 4px #E9FCE9","mainWhite":"#fff","inputTag":"fileInput_inputTag__EoDP0","fileInputBtn":"fileInput_fileInputBtn__QpLW0"};